import axios from 'axios'
import API from '@/common/api'

const IS_DEV = process.env.NODE_ENV === 'development'
const LINK_ID = 'custom-site-css'

let customSiteMap = null

async function loadCustomSiteMap() {
  if (customSiteMap) {
    return customSiteMap
  }

  const file = 'CUSTOM_SITE_MAP.json'
  const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=custom&file=${file}`)

  customSiteMap = res && res.data && res.data.message

  return customSiteMap
}

const loadCustomCss = async (cssUrl) => {
  return new Promise((resolve, reject) => {
    if (!cssUrl) return resolve(false)

    const existing = document.getElementById(LINK_ID)

    if (
      existing &&
      existing.getAttribute('href') === cssUrl
    ) {
      return resolve(true)
    }

    if (existing) {
      existing.parentNode &&
        existing.parentNode.removeChild(existing)
    }

    const link = document.createElement('link')

    link.id = LINK_ID
    link.rel = 'stylesheet'
    link.type = 'text/css'
    link.href = cssUrl

    link.onload = () => resolve(true)
    link.onerror = reject

    document.head.appendChild(link)
  })
}

const removeCustomCss = () => {
  const existing = document.getElementById(LINK_ID)

  if (existing) {
    existing.parentNode &&
      existing.parentNode.removeChild(existing)
  }
}

export async function getCustomSite(siteid) {
  if (!siteid) return undefined

  const siteMap = await loadCustomSiteMap()

  return siteMap[siteid]
}

export async function applySiteCustomCss(siteid) {
  const cssKey = await getCustomSite(siteid)

  if (!cssKey) {
    removeCustomCss()
    return false
  }

  const cssUrl =
    `${process.env.BASE_URL}custom_css/${cssKey}.css`

  await loadCustomCss(cssUrl)

  return true
}